import { render, staticRenderFns } from "./PatientCoachingSummaryLogs.vue?vue&type=template&id=3894e210"
import script from "./PatientCoachingSummaryLogs.vue?vue&type=script&lang=js"
export * from "./PatientCoachingSummaryLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports